import React from "react";
import { FormControl, Select, MenuItem } from "@mui/material";

const Dropdown = props => {

    const hasValue = Array.isArray(props.value) ? props.value.length > 0 : props.value !== '' && props.value != null && props.value !== undefined;
    const {theme, error, style, placeholder} = props;
    const {width, height} = style;

    const isDark = theme.White !== "#FFFFFF"
    const bgColor = isDark ? theme.Coco : theme.Checo

    //Renders the values as their respective labels
    const renderMultiValue = (selected) => {

        if(!selected || selected.length === 0) {
            return <span style={{color: theme.Lao, opacity: 0.7}}>{placeholder}</span>
        }

        const selectedOptions = selected.map(selectedValue => {
            //Get the matching value between the selected option and the MenuItem
            const menuItem = React.Children.toArray(props.children).find((child) => child.props.value === selectedValue);
            return menuItem ? menuItem.props.children : selectedValue; 
        });

        return selectedOptions.join(', ');
    }

    const renderSingleValue = (selected) => {
        if (!selected || selected === "") {
            return <span style={{color: theme.Lao, opacity: 1}}>{placeholder}</span> 
        }

        const menuItem = React.Children.toArray(props.children).find((child) => child.props.value === selected);
        return menuItem ? menuItem.props.children : selected;
    }

    return (
        <FormControl sx={{width: width, height: height}}>
            <Select 
                value={props.value}
                onChange={(e) => props.onChange(e.target.value)}
                multiple={props.multiple || false}
                disabled={props.disabled}
                displayEmpty
                renderValue={props.multiple ? renderMultiValue : undefined}
                sx={{
                    backgroundColor: bgColor, //Color del fondo
                    '& .MuiSelect-select': {    //Color de la letra
                        color: theme.Black,
                        opacity: props.disabled ? .5 : 1 
                    },
                    '& .MuiOutlinedInput-notchedOutline': { //Color del contorno ()
                        borderColor: error ? theme.Red : (hasValue ? theme.Coco : theme.Ey),
                        borderWidth: error ? '1.5px' : '1px'
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        boxShadow: `
                            0 0 0 1px ${theme.Magenta},
                            0 0 0 2px ${theme.Cyan}
                        `,
                        borderColor: 'transparent', //If changed to a color, it'll renderize in addition to the boxShadow...
                    },
                    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.Ey,
                        opacity: .5,
                    },
                    width: width,
                    height: height,
                    borderRadius: '4px',
                    gap: '12px',
                    borderWidth: '1px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    paddingRight: '8px'
                }}
                MenuProps={{
                    PaperProps:{
                        sx:{
                            maxHeight: 300,  //Alto del área de selección del Select
                            backgroundColor: theme.White,
                            color: theme.Black,
                            backgroundImage: 'none',
                            '& .MuiMenuItem-root': {
                                '&:hover': {
                                    backgroundColor: theme.Checo
                                },
                                '&.Mui-selected': {
                                    backgroundColor: theme.Ey,
                                    '&:hover': {
                                        backgroundColor: theme.Coco
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                {props.children}
                <MenuItem disabled value="" sx={{display: 'none'}}>{placeholder}</MenuItem>
            </Select>
        </FormControl>
    );
};

export default Dropdown;